import { unwrapResult } from '@reduxjs/toolkit'
import { Col, message, Modal, notification, Pagination, Spin, Table, Tooltip } from 'antd'
import moment from 'moment'
import React, {
  forwardRef,
  ReactElement,
  useContext,
  useEffect,
  useImperativeHandle,
  useMemo,
  useState,
} from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { RootDispatch } from '../../../app/store'
import { EditableList } from '../../../compnents/list/EditableList'
import { Columns, AGColumns } from './columns'
import styles from '../transactionQueryTab.module.css'
import { Query } from './Query'
import { ThemeContext } from '../../../theme/ThemeContext'
import {
  getPageColumnListAsync,
  getSubmitPageColumnListAsync,
  getTransactionDetailQueryTotal,
  getTransactionQueryExport,
  getTransactionQueryList,
  getTransactionQueryTotal,
  setExportLoading,
} from '../transactionQuerySlice'
import { getDateRange, DateRangeType } from '../../../compnents/form/DateSelect'
import {
  DateTimeFormatSimple,
  DateTimeFormatSimpleOnly,
  DateTimeFormatSimpleOnlyOne,
} from '../../../models/datetime'
import {
  cancelSaleUpload,
  getPaymentResult,
  isCancelUpload,
  selectResult,
} from '../../payment/result/paymentResultSlice'
import {
  getPaymentDetail,
  JuhePremium,
  refund as refundPayment,
} from '../../payment/list/paymentSlice'
import { getPayFlagName, Payment } from '../../../models/payment'
import {
  selectEdition,
  selectInsuranceArray,
  selectTenantAddress,
  selectTenantAreaCd,
  selectTenantCategory,
  selectTenantName,
  selectUserId,
  selectUserName,
} from '../../../app/applicationSlice'
import { getCardType } from '../../payment/JuhePayPage/columns'
import { getTransactionQueryName } from '../../../models/TransactionQuery'
import { singleZlPrintBody } from '../../../models/transactionQueryPrint'
import { result, sum } from 'lodash'
import { traceRoute } from '../../../layouts/layoutSlice'
import { RealPayModal } from '../../payment/list/realPayModal'
import { Refund } from '../../../models/refund'
import {
  selectInsuranceItem,
  setInsurance,
} from '../../../layouts/insuranceSlice'
import {
  strParse,
  medicalSendHttp,
  getTradeName,
  readCardSHttp,
  readCardEHttp,
} from '../../../utils/MedicalUtils'
import { cancelSettlementAsync } from '../../payment/confirm/paymentConfirmSlice'
import { TableRowSelection } from 'antd/lib/table/interface'
import { DataType } from '../../putstorage/putstorage'
import { PatientModal } from '../../patient/modals/PatientModal'
import { getTradeCode } from '../../../models/material'
import { getPatientInfoAsync } from '../../registration/register/registerSlice'
import SimpleAgGrid from '../../../compnents/simpleTable/SimpleAgGrid'
import { getSortColumnList } from '../../../models/common'
import { ConsoleSqlOutlined } from '@ant-design/icons'
import { removeSale3507AAsync } from '../../putstorage/putstorageSlice'
import { serverType } from '../../../services/commodity'

interface TransactionQueryProps {
  selectedTab?: any
  flag?: any
}
export interface TransactionQueryRef {
  reload: () => void
  outClude: () => void
}

const TransactionQuery = (
  { selectedTab, flag }: TransactionQueryProps,
  ref: React.Ref<TransactionQueryRef>
): ReactElement => {
  const theme = useContext(ThemeContext)

  const dispatch = useDispatch<RootDispatch>()

  const hisVersion: any = useSelector(selectEdition) //his版本 0通用 1口腔

  // 所有的列表
  const listData: any = [
    {
      headerName: '',
      field: 'checkbox',
      checkboxSelection: true,
      headerCheckboxSelection: true,  // 启用表头复选框（全选功能）
      width: 50,
      minWidth: 50,
      pinned: 'left',// 将列固定在左侧
      lockPosition: "left", // 锁定列位置，防止列移动
      suppressMovable: true, // 防止列被拖动
      resizable: false, //防止列宽被调整
      visible: true,
    },
    {
      headerName: '序号',
      width: 80,
      minWidth: 80,
      field: 'index',
      pinned: 'left',
      lockPosition: "left",
      suppressMovable: true,
      visible: true,
    },
    {
      headerName: '患者姓名',
      field: 'patientName',
      width: 120,
      minWidth: 120,
      pinned: 'left',
      lockPosition: "left",
      suppressMovable: true,
      visible: true,
    },
    {
      headerName: '结算险种',
      field: 'insuranceCode',
      minWidth: 120,
      filter: false,
      visible: true,
    },
    {
      headerName: '总金额',
      field: 'totalPrice',
      minWidth: 120,
      visible: true,
    },
    {
      headerName: '应收总金额',
      field: 'shouldPayAmount',
      minWidth: 120,
      visible: false,
    },
    {
      headerName: '实收总金额',
      field: 'totalRealAmount',
      minWidth: 120,
      visible: false,
    },
    {
      headerName: '报销金额',
      field: 'insurancePayAmount',
      minWidth: 120,
      visible: true,
    },
    {
      headerName: '现金金额',
      field: 'cashAmount',
      minWidth: 120,
      visible: true,
    },
    {
      headerName: '欠费金额',
      field: 'arrearageAmount',
      minWidth: 120,
      visible: true,
    },
    {
      headerName: '超限价金额',
      field: 'overlmtSelfpay',
      minWidth: 120,
      visible: true,
    },
    {
      headerName: '收款人',
      field: 'userName',
      minWidth: 120,
      visible: true,
    },
    {
      headerName: '接诊医生',
      field: 'treatmentDoctorName',
      minWidth: 120,
      visible: true,
    },
    {
      headerName: '助理医师',
      field: 'treatmentAssistantDoctorName',
      align: 'center',
      minWidth: 120,
      visible: true,
    },
    {
      headerName: '读卡方式',
      field: 'cardType',
      minWidth: 120,
      visible: true,
    },
    {
      headerName: '支付方式',
      field: 'payMethodName',
      minWidth: 120,
      visible: true,
    },
    {
      headerName: '收费标志',
      field: 'settlementCategory',
      minWidth: 120,
      visible: true,
    },
    {
      headerName: '病历号',
      field: 'patientId',
      minWidth: 120,
      visible: true,
    },
    {
      headerName: '手机号',
      field: 'patientPhone',
      minWidth: 120,
      visible: true,
    },
    {
      headerName: '收费时间',
      field: 'chargeOrRefundTime',
      // width: savedWidths['chargeOrRefundTime'] || 170,
      width: 170,
      minWidth: 170,
      pinned: 'right',
      // flex: 1,
      lockPosition: "right",
      suppressMovable: true,
      visible: true,
    },
    {
      headerName: '结算状态',
      field: 'state',
      width: 120,
      minWidth: 120,
      pinned: 'right',
      lockPosition: "right",
      // flex: 1,
      suppressMovable: true,
      visible: true,
    },
    {
      headerName: '操作',
      field: 'action',
      width: 120,
      minWidth: 120,
      pinned: 'right',
      lockPosition: "right",
      suppressMovable: true,
      visible: true,
    },
  ]?.map((v,index)=>{
    return {
      ...v,
      index: index + 1,
    }
  })

  const allData = hisVersion == '1' ? listData : listData?.filter((v: any) => v.field != 'treatmentAssistantDoctorName')

  // 默认要展示的列的值
  const selectColumns = allData?.filter((v: any) => v.visible)?.map((item: any) => item.field) || []

  const [allColumnList, setAllColumnList] = useState<any[]>([]) //筛选列所有的数据

  // 筛选列所有的数据
  const [filterColumnList, setFilterColumnList] = useState<any[]>([])

  const [filterSelectList, setFilterSelectList] = useState<any[]>([]) //筛选列所有的数据

  const [patient, setPatient] = useState<any>()

  const [allTotalData, setAllTotalData] = useState<any>()

  const [timeHead, timeTail] = getDateRange(DateRangeType.Today)

  const storageParams = JSON.parse(
    sessionStorage.getItem(location.pathname + '_jiaoyichaxun') || '{}'
  )

  const [params, setParams] = useState<any>({
    current: storageParams?.current ? Number(storageParams?.current) : 1,
    size: 20,
  })

  const [selectedKeys, setSelectedKeys] = useState<any>([])

  const tenantName = useSelector(selectTenantName)

  const [page, setPage] = useState<any>()

  const [pageLoading, setPageLoading] = useState(false)

  const [isReplaceMakeVisible, setIsReplaceMakeVisible] = useState(false)

  const [isDetailModalVisible, setIsDetailModalVisible] = useState<any>(false)

  const [refund, setRefund] = useState<Refund | undefined>()

  const result = useSelector(selectResult) //预退费详情接口

  const [buttonLoading, setButtonLoading] = useState(false)

  const [stkButtonLoading, setStkButtonLoading] = useState(false)

  const [dzpzButtonLoading, setDzpzButtonLoading] = useState(false)

  const [ybFaceButtonLoading, setYbFaceButtonLoading] = useState(false)

  const [scrollHeight, setScrollHeight] = useState<any>()

  const [tableId, setTableId] = useState('')

  const [refundParams, setRefundParams] = useState<any>()

  const [totalData, setTotalData] = useState<any>()

  const [sureReplaceMakeVisible, setSureReplaceMakeVisible] = useState(false)

  const [insuranceItem, setInsuranceItem] = useState<any>()

  const [releasingTimeFlag, setReleasingTime] = useState(false)

  const insuranceArray = useSelector(selectInsuranceArray)

  const userName = useSelector(selectUserName)

  const userId = useSelector(selectUserId)

  const tenantAddress = useSelector(selectTenantAddress)

  const tenantAreaCd = useSelector(selectTenantAreaCd)

  const tenantCategory = useSelector(selectTenantCategory)

  const cycleCode = sessionStorage.getItem('cycleCode')


  const baseData = useSelector(selectInsuranceItem)

  useEffect(() => {
    setReleasingTime(false)
  }, [])

  const submitPageList = (data: any) => {
    const params = {
      pageName: 'transactionQuery',
      configJson: JSON.stringify(data),
    }
    dispatch(getSubmitPageColumnListAsync({
      ...params,
    }))
      .then(unwrapResult)
      .then((v: any) => {
        getPageColumnList(v?.id)
      })
  }

  const getPageColumnList = (id?: any) => {
    dispatch(getPageColumnListAsync({
      id: id ? id : undefined,
      pageName: 'transactionQuery',
    }))
      .then(unwrapResult)
      .then((v: any) => {
        const data: any = v?.configJson ? JSON.parse(v?.configJson) : []
        const filterList = data?.filter((n: any) => n?.visible)
        const columns = filterList?.map((n: any) => n?.field)
        const sameFileds = allData?.find((item: any) => item?.field == v?.field)
        const resetData = data?.map((v: any) => ({
          ...v,
          minWidth: sameFileds?.minWidth || v?.minWidth,
          width: sameFileds?.width || v?.width,
          headerName: sameFileds?.headerName || v?.headerName,
        }))
        // 所有的数据
        setAllColumnList(data?.length ? resetData : allData)
        // 筛选后存在后端的数据
        setFilterColumnList(filterList?.length ? filterList : allData)
        // 选中的值
        setFilterSelectList(columns?.length ? columns : selectColumns)
      })
      .catch(() => {
        setAllColumnList(allData)
        setFilterColumnList(allData)
        setFilterSelectList(selectColumns)
      })
      .finally(() => {
        setPageLoading(false)
      })
  }

  useEffect(() => {
    if (selectedTab == '1') {
      setAllColumnList(allData)
    }
  }, [selectedTab])

  useEffect(() => {
    if (selectedTab == '1') {
      setPageLoading(true)
      if (params?.registrationTimeHead && params?.registrationTimeTail) {
        getPage()
        getPageColumnList()
      }
    }
  }, [selectedTab, params])

  useEffect(() => {
    setButtonLoading(false)
    setDzpzButtonLoading(false)
    setStkButtonLoading(false)
  }, [])

  const refondSubmit = (id: any) => {
    setButtonLoading(true)
    dispatch(refundPayment(id))
      .then(unwrapResult)
      .then(() => {
        setButtonLoading(false)
        setStkButtonLoading(false)
        setDzpzButtonLoading(false)
        setRefund(undefined)
        getPage()
      })
      .catch(() => {
        setButtonLoading(false)
        setStkButtonLoading(false)
        setDzpzButtonLoading(false)
      })
  }

  useEffect(() => {
    if (!tableId) return
    result &&
      dispatch(getPaymentDetail(tableId))
        .then(unwrapResult)
        .then((refund) => {
          setRefund(refund)
        })
  }, [result])

  useEffect(() => {
    if (insuranceArray.length !== 0) {
      setInsuranceItem(insuranceArray[0])
    }
  }, [insuranceArray])

  // 保存医保结构体
  useEffect(() => {
    if (insuranceItem && JSON.stringify(insuranceItem) !== '{}') {
      dispatch(
        setInsurance({
          ...insuranceItem,
          userName,
          userId,
          cycleCode,
          tenantCategory,
          tenantAreaCd,
          name: tenantName,
          address: tenantAddress,
          areaCode: tenantAreaCd,
          endTime: moment(insuranceItem.endTime).format(
            DateTimeFormatSimpleOnlyOne
          ),
        })
      )
    }
    return () => {
      dispatch(setInsurance({}))
    }
  }, [insuranceItem])

  // 销售单删除接口3507A
  const removeSale3507A = (
    serverType: serverType,
    paymentId: number,
    responseString?: string
  ) => {
    dispatch(
      removeSale3507AAsync({
        serverType,
        body: {
          baseData: {
            ...baseData,
            responseString,
          },
          paymentId
        },
      })
    )
      .then(unwrapResult)
      .then((res) => {
        if (serverType === 'requestString') {
          const data = strParse(res)
          medicalSendHttp(
            {
              trade_args: [
                data.infno,
                data.url,
                data,
                baseData?.countryHospitalNb,
                baseData?.secretToken,
              ],
              message: '冲正上传',
            },
            (call: any, err) => {
              !err &&
                removeSale3507A(
                  'response',
                  paymentId,
                  JSON.stringify(call.netmessage)
                )
            }
          )
        } else {
          dispatch(cancelSaleUpload(String(paymentId)))
            .then(unwrapResult)
            .then(async (val: any) => {
              notification.success({
                message: "追溯码上传撤销成功",
              })
            })
        }
      })
  }

  const cancelSettlement = (
    serverType: any,
    paymentId?: string,
    cardType?: string,
    fullCardInfo?: string,
    responseString?: string
  ) => {
    const insuranceItem = insuranceArray.find(
      (v: any) => v.insuranceCode === refund?.insuranceCode
    )
    dispatch(
      cancelSettlementAsync({
        serverType,
        body: {
          baseData: {
            ...baseData,
            responseString,
          },
          exp_content: '',
          treatmentId: refund?.treatmentId,
          paymentId,
        },
      })
    )
      .then(unwrapResult)
      .then(async (res: any) => {
        if (serverType === 'requestString') {
          const data = strParse(res)
          await medicalSendHttp(
            {
              trade_args: [
                data.infno,
                data.url,
                data,
                insuranceItem.countryHospitalNb,
                insuranceItem.secretToken,
              ],
              notification: '退费',
            },
            (call: any, err) => {
              if (!err) {
                cancelSettlement(
                  'response',
                  paymentId,
                  cardType,
                  fullCardInfo,
                  JSON.stringify(call.netmessage)
                )
              }
              setStkButtonLoading(false)
              setDzpzButtonLoading(false)
            }
          )
        } else {
          refondSubmit(refund?.id)
          // resolve()
          //更新医保卡数据
          if (cardType == '1') {
            //实体卡
            getPatientInfo(
              '3',
              baseData?.insuranceCode == 'JIANGSU'
                ? String(fullCardInfo)
                : JSON.stringify(fullCardInfo),
              'requestString'
            )
          } else if (cardType == '2') {
            //电子凭证
            getPatientInfo('1', String(fullCardInfo), 'requestString')
          }

          // 退费成功后，撤销追溯码3507A （仅限浙江医保机构）
          if (refund?.ybSaleUploadStatus == 1 && insuranceItem && insuranceItem?.insuranceCode == 'ZHEJIANG') {
            removeSale3507A('requestString', Number(refund?.id))
          }

          const data = res?.req2205 ? strParse(res?.req2205) : ''
          if (data) {
            await medicalSendHttp(
              {
                trade_args: [
                  data?.infno,
                  data?.url,
                  data,
                  insuranceItem.countryHospitalNb,
                  insuranceItem.secretToken,
                ],
                notification: '退费撤销明细',
              },
              (call: any, err) => {
                return
              }
            )
          }
          // submit(vs, undefined, res)
        }
      })
      .catch((v) => {
        setStkButtonLoading(false)
        setDzpzButtonLoading(false)
      })
  }

  const success = (str: string) => {
    const hide = message.loading(str, 0)
    setTimeout(() => {
      hide()
    }, 3000)
  }

  // 获取参保人信息
  const getPatientInfo = (
    cardType: string,
    fullCardInfo: string,
    serverType: any,
    responseString?: string
  ) => {
    dispatch(
      getPatientInfoAsync({
        serverType,
        body: {
          baseData: {
            ...baseData,
            responseString,
          },
          cardType: String(cardType) == "11" ? '1' : String(cardType),
          fullCardInfo,
          otherMap: {},
        },
      })
    )
      .then(unwrapResult)
      .then(async (res) => {
        if (serverType === 'requestString') {
          const data = strParse(res)
          await medicalSendHttp(
            {
              trade_args: [
                data.infno,
                data.url,
                data,
                insuranceItem.countryHospitalNb,
                insuranceItem.secretToken,
              ],
            },
            (call: any, err) => {
              if (!err) {
                message.loading('正在更新人员信息')
                getPatientInfo(
                  cardType,
                  fullCardInfo,
                  'response',
                  JSON.stringify(call.netmessage)
                )
                // }
              }
            }
          )
        } else {
          message.success('人员信息已更新')
        }
      })
      .catch((ex) => {
        notification.error({
          message: ex.message,
          duration: 3,
        })
      })
  }

  const getPage = () => {
    dispatch(getTransactionQueryList({ ...params, selectedTab: undefined }))
      .then(unwrapResult)
      .then((v: any) => {
        onResize() // 初始化设置高度
        window.addEventListener('resize', onResize)
        setPage({
          items: v?.records,
          size: v?.size,
          total: v?.total,
          current: v?.current,
        })
        dispatch(getTransactionQueryTotal(params))
          .then(unwrapResult)
          .then((v: any) => {
            setAllTotalData(v)
            setPageLoading(false)
          })
          .catch(() => {
            setPageLoading(false)
          })
      })
      .catch(() => {
        setPageLoading(false)
      })
  }

  useEffect(() => {
    params.current &&
      sessionStorage.setItem(
        location.pathname + '_jiaoyichaxun',
        JSON.stringify({ ...params })
      )
  }, [params])

  // 计算合计数据
  useEffect(() => {
    if (selectedKeys?.length) {
      const data = page?.items?.filter((v: any) => v?.state != 5)
      if (data?.length) {
        // 过滤出的包含勾选的所有数据
        const filterList: any = []
        selectedKeys.forEach((item: any) => {
          data.forEach((element: any) => {
            if (item == element.paymentId) {
              filterList.push(element)
            }
          })
        })
        // 计算合计
        const totalPriceAll = sum(
          filterList?.map((v: any) =>
            v?.totalPrice > -1 ? Number(v?.totalPrice) : 0
          )
        )
        const insurancePayAmountAll = sum(
          filterList?.map((v: any) =>
            v?.insurancePayAmount > -1 ? Number(v?.insurancePayAmount) : 0
          )
        )
        const cashAmountAll = sum(
          filterList?.map((v: any) =>
            v?.cashAmount > -1 ? Number(v?.cashAmount) : 0
          )
        )
        const arrearageAmountAll = sum(
          filterList?.map((v: any) =>
            v?.arrearageAmount > -1 ? Number(v?.arrearageAmount) : 0
          )
        )
        const overlmtSelfpayAll = sum(
          filterList?.map((v: any) =>
            v?.overlmtSelfpay > -1 ? Number(v?.overlmtSelfpay) : 0
          )
        )

        const shouldPayAmountAll = sum(
          filterList?.map((v: any) =>
            v?.shouldPayAmount > -1 ? Number(v?.shouldPayAmount) : 0
          )
        )
        const totalRealAmountAll = sum(
          filterList?.map((v: any) =>
            v?.totalRealAmount > -1 ? Number(v?.totalRealAmount) : 0
          )
        )
        setTotalData({
          shouldPayAmountAll: shouldPayAmountAll,
          totalRealAmountAll: totalRealAmountAll,
          totalPriceAll: totalPriceAll,
          insurancePayAmountAll: insurancePayAmountAll,
          cashAmountAll: cashAmountAll,
          arrearageAmountAll: arrearageAmountAll,
          overlmtSelfpayAll: overlmtSelfpayAll,
        })
      } else {
        setTotalData({
          shouldPayAmountAll: 0.0,
          totalRealAmountAll: 0.0,
          totalPriceAll: 0.0,
          insurancePayAmountAll: 0.0,
          cashAmountAll: 0.0,
          arrearageAmountAll: 0.0,
          overlmtSelfpayAll: 0.0,
        })
      }
    } else {
      const list = page?.items?.filter((v: any) => v?.state != 5)
      const data = !params?.state ? list : page?.items
      if (data?.length) {
        // 没勾选的情况下计算全部
        const totalPriceAll = sum(
          data?.map((v: any) =>
            v?.totalPrice > -1 ? Number(v?.totalPrice) : 0
          )
        )
        const insurancePayAmountAll = sum(
          data?.map((v: any) =>
            v?.insurancePayAmount > -1 ? Number(v?.insurancePayAmount) : 0
          )
        )
        const cashAmountAll = sum(
          data?.map((v: any) =>
            v?.cashAmount > -1 ? Number(v?.cashAmount) : 0
          )
        )
        const arrearageAmountAll = sum(
          data?.map((v: any) =>
            v?.arrearageAmount > -1 ? Number(v?.arrearageAmount) : 0
          )
        )
        const overlmtSelfpayAll = sum(
          data?.map((v: any) =>
            v?.overlmtSelfpay > -1 ? Number(v?.overlmtSelfpay) : 0
          )
        )

        const shouldPayAmountAll = sum(
          data?.map((v: any) =>
            v?.shouldPayAmount > -1 ? Number(v?.shouldPayAmount) : 0
          )
        )
        const totalRealAmountAll = sum(
          data?.map((v: any) =>
            v?.totalRealAmount > -1 ? Number(v?.totalRealAmount) : 0
          )
        )

        setTotalData({
          shouldPayAmountAll: shouldPayAmountAll,
          totalRealAmountAll: totalRealAmountAll,
          totalPriceAll: totalPriceAll,
          insurancePayAmountAll: insurancePayAmountAll,
          cashAmountAll: cashAmountAll,
          arrearageAmountAll: arrearageAmountAll,
          overlmtSelfpayAll: overlmtSelfpayAll,
        })
      } else {
        setTotalData({
          shouldPayAmountAll: 0.0,
          totalRealAmountAll: 0.0,
          totalPriceAll: 0.0,
          insurancePayAmountAll: 0.0,
          cashAmountAll: 0.0,
          arrearageAmountAll: 0.0,
          overlmtSelfpayAll: 0.0,
        })
      }
    }
  }, [page, selectedKeys])

  // 打印
  const dataMainList = {
    tenantName: tenantName?.split('-')?.[0],
    data: page?.items?.map((v: any) => {
      return {
        ...v,
        nameState:
          v?.state == 3
            ? '已收费'
            : v?.state == 5
              ? '已退费'
              : v?.state == 7
                ? '欠费中'
                : '',
        patientName: v?.patientName ? v?.patientName : '-',
        patientId: v?.patientId ? v?.patientId : '-',
        patientPhone: v?.patientPhone ? v?.patientPhone : '-',
        insuranceCode:
          v?.insuranceCode === 'ZIFEI' || !v?.insuranceCode
            ? '自费'
            : '智慧医保',
        totalPrice:
          v?.state == 5
            ? 0
            : Number(v?.totalPrice) > 0
              ? Number(v?.totalPrice)?.toFixed(2)
              : '0.00',
        insurancePayAmount:
          Number(v?.insurancePayAmount) > 0
            ? Number(v?.insurancePayAmount)?.toFixed(2)
            : '0.00',
        cashAmount:
          Number(v?.cashAmount) > 0
            ? Number(v?.cashAmount)?.toFixed(2)
            : '0.00',
        arrearageAmount:
          Number(v?.arrearageAmount) > 0
            ? Number(v?.arrearageAmount)?.toFixed(2)
            : '0.00',
        overlmtSelfpay:
          Number(v?.overlmtSelfpay) > 0
            ? Number(v?.overlmtSelfpay)?.toFixed(2)
            : '0.00',
        jibenylbxtcjjzc:
          Number(v?.jibenylbxtcjjzc) > 0
            ? Number(v?.jibenylbxtcjjzc)?.toFixed(2)
            : '0.00',
        discountAmount:
          Number(v?.discountAmount) > 0
            ? Number(v?.discountAmount)?.toFixed(2)
            : '0.00',
        gerenzhzc:
          Number(v?.gerenzhzc) > 0 ? Number(v?.gerenzhzc)?.toFixed(2) : '0.00',
        treatmentDoctorName: v?.treatmentDoctorName
          ? v?.treatmentDoctorName
          : '0.00',
        cardType: v?.cardType ? getCardType(v?.cardType) : '-',
        settlementCategory: v?.settlementCategory
          ? getPayFlagName(v?.settlementCategory)
          : '-',
        userName: v?.userName ? v?.userName : '-',
        chargeOrRefundTime: v?.chargeOrRefundTime
          ? moment(v?.chargeOrRefundTime)?.format(DateTimeFormatSimple)
          : '-',
        state: v?.state ? getTransactionQueryName(Number(v?.state)) : '-',
        stateNumber: v?.state,
      }
    }),
    timeHead: moment(params?.registrationTimeHead).format(
      DateTimeFormatSimpleOnly
    ),
    timeTail: moment(params?.registrationTimeTail).format(
      DateTimeFormatSimpleOnly
    ),
  }

  useImperativeHandle(ref, () => ({
    reload: () => {
      const content = singleZlPrintBody(dataMainList)
      const page: any = window.open('', '_blank') // 打开一个新窗口，用于打印
      page.document.write(content) // 写入打印页面的内容
      page.print() // 打印
      page?.close()
    },
    outClude: () => {
      outCluedExport()
    },
  }))

  const outCluedExport = () => {
    dispatch(setExportLoading(true))
    dispatch(
      getTransactionQueryExport({
        ...params,
        releasingTime: releasingTimeFlag ? '99' : undefined,
      })
    )
      .then(unwrapResult)
      .then((res: any) => {
        const content = res
        const blob = new Blob([content])
        const fileName = '交易查询.xlsx'
        const selfURL = window[window.webkitURL ? 'webkitURL' : 'URL']
        const elink = document.createElement('a')
        if ('download' in elink) {
          elink.download = fileName
          elink.style.display = 'none'
          elink.href = selfURL['createObjectURL'](blob)
          document.body.appendChild(elink)
          // 触发链接
          elink.click()
          selfURL.revokeObjectURL(elink.href)
          document.body.removeChild(elink)
        } else {
          return (navigator as any).msSaveBlob(blob, fileName)
        }
      })
      .then(() => {
        notification.success({
          message: '导出成功',
          duration: 3,
        })
      })
      .catch((res: any) => {
        notification.success({
          message: '导出失败',
          duration: 3,
        })
      })
      .finally(() => {
        dispatch(setExportLoading(false))
      })
  }

  // 表格双击跳转
  const tableDoubleFn = (record: any) => {
    if (record?.state == 3 || record?.state == 5 || record?.state == 7) {
      dispatch(
        traceRoute({
          name: '收费',
          path: '/payment/result',
          query: `paymentId=${record.paymentId}&status=${record?.state
            }&selectedTab=${selectedTab}&name=${'交易查询'}`,
          state: {
            name:
              record?.state == 3
                ? '已收费'
                : record?.state == 5
                  ? '已退费'
                  : record?.state == 7
                    ? '欠费中'
                    : '',
            path: '/transactionQuery',
            routeName: '交易查询',
          },
        })
      )
    }
  }

  const doRefund = (cardType?: string, fullCardInfo?: string) => {
    const payMethodList = refund?.payMethod?.toString()?.split(',')
    const isJuHe: any = payMethodList?.find((v: any) => {
      return v == 2
    })
    if (isJuHe) {
      //是否聚合支付退费
      dispatch(
        JuhePremium({
          treatmentId: refund?.treatmentId || '',
          paymentId: refund?.id || '',
        })
      )
        .then(unwrapResult)
        .then(() => {
          setStkButtonLoading(false)
          setDzpzButtonLoading(false)
          notification.success({ message: '聚合支付退费成功' })
          if (refund) {
            if (refund.insuranceCode !== 'ZIFEI') {
              cancelSettlement(
                'requestString',
                refund.id,
                cardType,
                fullCardInfo
              )
            } else {
              refondSubmit(refund.id)

              // 退费成功后，撤销追溯码3507A
              if (refund?.ybSaleUploadStatus == 1 && insuranceItem && insuranceItem?.insuranceCode == 'ZHEJIANG') {
                removeSale3507A('requestString', Number(refund?.id))
              }
            }
          }
        })
        .catch((v) => {
          setStkButtonLoading(false)
          setDzpzButtonLoading(false)
        })
    } else {
      if (refund) {
        if (refund.insuranceCode !== 'ZIFEI') {
          cancelSettlement('requestString', refund.id, cardType, fullCardInfo)
        } else {
          refondSubmit(refund.id)

          // 退费成功后，撤销追溯码3507A
          if (refund?.ybSaleUploadStatus == 1 && insuranceItem && insuranceItem?.insuranceCode == 'ZHEJIANG') {
            removeSale3507A('requestString', Number(refund?.id))
          }
        }
      }
    }
  }

  const validCardInfoBeforeGoRefund = (type: string) => {
    //实体卡读卡校验
    if (type == '1') {
      setStkButtonLoading(true)
      //部分强制读卡的地区，跳过校验
      const tradeType = getTradeName()
      if (tradeType === 'CQ_ZHYB') {
        doRefund()
        return
      }
      readCardSHttp(
        {
          trade_args: [getTradeCode(tenantAreaCd.slice(0, 4))],
        },
        (data, err) => {
          if (!err) {
            //其他地区需要做二次读卡校验
            const Name =
              tradeType === 'JS_ZHYB'
                ? data?.netmessage
                  ?.split('|')[4]
                  ?.replace('\r', '')
                  .replace('\t', '')
                  .replace(' ', '')
                  .trim()
                : data?.netmessage?.Name
            if (Name != refund?.patientName) {
              Modal.error({
                title: '提示',
                content:
                  `退费信息与卡片信息不一致，请确认是否插错卡，就诊人：` +
                  refund?.patientName +
                  '，卡片姓名：' +
                  data?.netmessage.Name,
                okText: '确认',
              })
              setStkButtonLoading(false)
            } else {
              doRefund(type, data?.netmessage)
            }
          }
        }
      )
      //电子凭证读卡校验
    } else if (type == '2') {
      setDzpzButtonLoading(true)
      setTimeout(() => {
        setDzpzButtonLoading(false)
      }, 3000)
      readCardEHttp(
        {
          trade_args: [
            baseData?.countryHospitalNb,
            '01301',
            '',
            userId,
            userName,
            '',
            '',
          ],
        },
        (data, err) => {
          if (!err) {
            // {"netcode":"1","netmessage":"徐春霞|330621198804253802|01|330000ecaqm4mb0mvk0b8fab0a0000236f0d3c|330182|","QrCode":"","ChnlId":""}
            const readName = data?.netmessage?.split('|')[0]
            if (readName != refund?.patientName) {
              Modal.error({
                title: '提示',
                content:
                  `退费信息与卡片信息不一致，请确认是否插错卡，就诊人：` +
                  refund?.patientName +
                  '，电子凭证姓名：' +
                  readName,
                okText: '确认',
              })
              setDzpzButtonLoading(false)
            } else {
              doRefund(type, data?.netmessage)
            }
          }
        }
      )
      //自费直接调用退费
    } else if (type == '3') {
      doRefund()
      //自费直接调用退费
    } else if (type == '0') {
      doRefund()
    } else if (type == '4') {
      setYbFaceButtonLoading(true)
      setTimeout(() => {
        setYbFaceButtonLoading(false)
      }, 3000)
      readCardEHttp(
        {
          trade_args: [
            baseData?.countryHospitalNb,
            '01301',
            'cn.nhsa.ec.auth',
            userId,
            userName,
            '',
            '',
          ],
        },
        (data, err) => {
          if (!err) {
            const readName = data?.netmessage?.split('|')[0]
            if (readName != refund?.patientName) {
              Modal.error({
                title: '提示',
                content:
                  `退费信息与刷脸人员信息不一致，请确认是否插错卡，就诊人：` +
                  refund?.patientName +
                  '，扫脸姓名：' +
                  readName,
                okText: '确认',
              })
              setYbFaceButtonLoading(false)
            } else {
              doRefund(type, data?.netmessage)
            }
          }
        }
      )
    } else {
      Modal.error({
        title: '错误',
        content: `未知的退费类型` + type + `请联系客服人员处理`,
        okText: '确认',
      })
    }
  }

  const onResize = () => {
    const table = document.getElementById('tableHeights')
    if (table) {
      const height = table.offsetHeight - 60 - 80 - 20
      setScrollHeight(height)
    } else {
      return '100%'
    }
  }

  return (
    <>
      <Col
        style={{
          backgroundColor: theme.pn,
          borderRadius: 10,
          display: 'flex',
          flexDirection: 'column',
          height: 'calc(100% - 10px)',
          marginTop: flag ? 0 : '10px',
          overflow: 'hidden',
          padding: flag ? 0 : '10px 15px 20px 15px',
        }}
      >
        <Query
          loading={pageLoading}
          onValueChange={(v: any) => {
            setSelectedKeys([])
            const paramData = {
              ...params,
              ...v,
              registrationTimeHead: v?.timeHead
                ? moment(v?.timeHead).format(DateTimeFormatSimpleOnlyOne)
                : moment(timeHead).format(DateTimeFormatSimpleOnlyOne),
              registrationTimeTail: v?.timeTail
                ? moment(v?.timeTail).format(DateTimeFormatSimpleOnlyOne)
                : moment(timeTail).format(DateTimeFormatSimpleOnlyOne),
              timeHead: undefined,
              timeTail: undefined,
              current: v?.current
                ? v?.current
                : storageParams?.current
                  ? storageParams?.current
                  : 1,
            }
            setParams({
              ...paramData,
            })
          }}
          selectedTab={selectedTab}
          alertMessage={() => {
            alert('Service mode is open')
            setReleasingTime(true)
          }}
          filterColumn={allColumnList} //筛选列
          filterSelectList={filterSelectList}
          // 筛选列变化时的数据
          submitPageList={(v: any) => {
            setPageLoading(true)
            submitPageList(v)
            setAllColumnList(v)
          }}
        />
        <div
          style={{
            width: '100%',
            height: '100%',
          }}
        >
          <SimpleAgGrid
            page={page}
            column={(AGColumns(
              page?.size * (page?.current - 1),
              (action, id: any, t, settlementCategory) => {
                switch (action) {
                  case 'return':
                    setTableId(t?.paymentId)
                    if (t?.potionRecipeStatus !== 1) {
                      dispatch(getPaymentResult(id)) //获取预退费表格信息
                    } else {
                      setIsReplaceMakeVisible(true)
                      setRefundParams(t)
                    }
                    break
                }
              },
              (text, v) => {
                if (text == 'openDetail') {
                  setPatient({ ...v, id: v?.patientId })
                  setIsDetailModalVisible(true)
                }
              }, insuranceArray,
              allColumnList
            ))?.filter((item: any) => filterSelectList?.includes(item.field))}
            isLoading={pageLoading}
            pagination={true}
            pageKey={'transactionQuery'}
            rowSelection="multiple"
            onRowDoubleClick={(event: any) => tableDoubleFn(event.data)}
            onSelectionChange={(selectedRows, selectedNodes) => {
              setSelectedKeys(selectedRows.map((row: any) => row.paymentId))
            }}
            pinnedBottomRowData={[{
              totalPrice: totalData?.totalPriceAll?.toFixed(2) || '',
              shouldPayAmount: totalData?.shouldPayAmountAll?.toFixed(2) || '',
              totalRealAmount: totalData?.totalRealAmountAll?.toFixed(2) || '',
              insurancePayAmount: totalData?.insurancePayAmountAll?.toFixed(2) || '',
              cashAmount: totalData?.cashAmountAll?.toFixed(2) || '',
              arrearageAmount: totalData?.arrearageAmountAll?.toFixed(2) || '',
              overlmtSelfpay: totalData?.overlmtSelfpayAll?.toFixed(2) || '',
              // 剩余没有合计行的列展示为空
            }]}
            suppressRowClickSelection={true}
            // 配置底部行样式
            getRowStyle={(params) => {
              if (params.node.rowPinned) {
                return {
                  fontWeight: 'normal',
                  backgroundColor: '#D9F2FF',
                };
              }
              return {}; // 将返回 null 改为返回空对象，避免类型不匹配问题
            }}
            onChangePage={(current, size) => {
              setSelectedKeys([])
              setParams({
                ...params,
                current,
                size,
              })
              setPage({
                ...page,
                current,
                size,
              })
            }}
            onColumnResized={(v) => {
              return
            }}
            onColumnMoved={(v) => {
              // setPageLoading(true)
              const sortList = getSortColumnList(allColumnList, v);
              submitPageList(sortList)
              setAllColumnList(sortList)
            }}
          />
          <div style={{ position: 'absolute', bottom: '20px', left: '20px', lineHeight:(hisVersion != 1 && '60px') as any }}>共{page?.total} 条数据，总金额：{allTotalData?.totalPriceSum || '0.00'} ，报销金额：{allTotalData?.insurancePayAmountSum || '0.00'} ，现金金额：{allTotalData?.cashAmountSum || '0.00'} ，欠费金额：{allTotalData?.arrearageAmountSum || '0.00'}</div>
        </div>
        <RealPayModal
          buttonLoading={buttonLoading}
          stkButtonLoading={stkButtonLoading}
          dzpzButtonLoading={dzpzButtonLoading}
          ybFaceButtonLoading={ybFaceButtonLoading}
          refund={refund}
          onOK={(type) => {
            validCardInfoBeforeGoRefund(type)
          }}
          onCancel={() => setRefund(undefined)}
          resultData={result?.paymentDetailRecordVOS}
        />
        <Modal
          closable={false}
          maskClosable={false}
          cancelText='不撤销'
          okText='撤销'
          visible={isReplaceMakeVisible}
          title=''
          onOk={() => {
            setIsReplaceMakeVisible(false)
            dispatch(
              isCancelUpload({
                treatmentId: refundParams!.treatmentId,
                potionRecipeStatus: 3,
                paymentId: refundParams!.paymentId,
              })
            )
              .then(unwrapResult)
              .then(() => {
                dispatch(getPaymentDetail(refundParams!.paymentId))
                  .then(unwrapResult)
                  .then((refund) => {
                    // setRefund(refund)
                    dispatch(getPaymentResult(tableId)) //获取预退费表格信息
                  })
              })
          }}
          onCancel={() => {
            setIsReplaceMakeVisible(false)
            setSureReplaceMakeVisible(true)
          }}
        >
          本单已传至代煎方，需要撤销代煎吗？
        </Modal>
        <Modal
          visible={sureReplaceMakeVisible}
          title=''
          onOk={() => {
            setSureReplaceMakeVisible(false)
            dispatch(getPaymentDetail(refundParams!.paymentId))
              .then(unwrapResult)
              .then((refund) => {
                // setRefund(refund)
                dispatch(getPaymentResult(tableId)) //获取预退费表格信息
              })
          }}
          onCancel={() => {
            setSureReplaceMakeVisible(false)
          }}
        >
          退费时不撤销订单可能带来损失，确认不需要撤销代煎吗？
        </Modal>
        <PatientModal
          tag={true}
          status={1}
          patient={patient}
          // registrationId={registrationId}
          // treatmentId={treatmentId}
          visible={isDetailModalVisible}
          onCancel={() => setIsDetailModalVisible(false)}
          onOk={() => setIsDetailModalVisible(false)}
        />
      </Col>
    </>

  )
}

export const TransactionQuerys = forwardRef(TransactionQuery)
